import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW0D00DataDiv } from '../../../commons/kymw0d/kymw0d00/kymw0d00.model';
import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW9400Model } from './kymw9400.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FileUploadService, FileAccept } from './../../../commons/kymw02/file-upload/file-upload.service';
import { KYMW0D00Component } from '../../../commons/kymw0d/kymw0d00/kymw0d00.component';
import { KYMW0D00InputModel } from '../../../commons/kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { ImportBudgetService } from './api-servicese/import-budget.service';
import { ImportBusinessCalenderService } from './api-servicese/import-business-calender.service';
import { ImportDistributionRatioService } from './api-servicese/import-distribution-ratio.service';
import { ImportUseNumPeopleService } from './api-servicese/import-use-num-people.service';

/**
 * 外部システム連携画面を管理するクラス
 *
 * @export KYMW9400Component
 * @class KYMW9400Component
 */
@Component({
  selector: 'app-kymw9400',
  templateUrl: 'kymw9400.component.html',
  styleUrls: ['kymw9400.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9400Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  KYMW9400Model: KYMW9400Model = new KYMW9400Model();
  KYMW0D00InputVO: KYMW0D00InputModel = new KYMW0D00InputModel();

  @ViewChild('btn_Close', { static: true }) btn_Close: ElementRef;

  /**
   * Creates an instance of KYMW9400Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {FileUploadService} fileUploadService
   * @param {ImportBudgetService} importBudgetService
   * @param {ImportBusinessCalenderService} importBusinessCalenderService
   * @param {ImportDistributionRatioService} importDistributionRatioService
   * @param {ImportUseNumPeopleService} importUseNumPeopleService
   * @memberof KYMW9400Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private fileUploadService: FileUploadService,
    private importBudgetService: ImportBudgetService,
    private importBusinessCalenderService: ImportBusinessCalenderService,
    private importDistributionRatioService: ImportDistributionRatioService,
    private importUseNumPeopleService: ImportUseNumPeopleService,
    private elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9400';

    // 権限取得
    if (this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {    // 「2：フルコントロール」の場合
      //「営業日カレンダー」を選択状態にする
      this.KYMW9400Model.uploadType = '1';
    } else {
      this.btn_Close.nativeElement.focus();
    }
  }

  /**
   * 「営業カレンダー」を選択した状態で、「取込」ボタンを押下時に呼び出されるメソッド。
   */
  public fileBusinessCalendarUpload(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 拡張子取得(小文字に変換して取得する)
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      // 取得した拡張子が想定されているものかチェック
      if (extension !== 'csv') {
        this.dialogService.openAlertGetMessage('E0220');
      } else {
        // 営業カレンダー取込処理
        this.importBusinessCalenderService.execute(selectedFiles[0], (data: any) => {
          const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
          // 画面ＩＤ
          inpVO.dispId = 'KYMW9400';
          // データ区分
          inpVO.dataDiv = KYMW0D00DataDiv.DATA_DIV_KYMW9400_CATALOG;
          // 正常件数
          inpVO.normalNum = data.NormalCount;
          // 注意件数
          inpVO.attentionNum = data.AttentionCount;
          // 異常件数
          inpVO.abnormalNum = data.AbnormalityCount;
          // ＤＢ更新件数
          inpVO.updateNum = data.DBExecuteCount;
          // 処理件数
          inpVO.manageNum = data.TotalExecuteCount;

          const ref = this.dialogService.openModal(KYMW0D00Component);
          const inst = ref.componentInstance as KYMW0D00Component;

          inst.parent = this;
          inst.setInterfaceParam(inpVO);
          inst.closeFunction = () => {
            ref.close();
          };
        });
      }
    }, [FileAccept.CSV]);
  }

  /**
   * 「利用予算人数」を選択した状態で、「取込」ボタンを押下時に呼び出されるメソッド。
   */
  public fileUseBudgetNumberUpload(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 拡張子取得(小文字に変換して取得する)
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      // 取得した拡張子が想定されているものかチェック
      if (extension !== 'csv') {
        this.dialogService.openAlertGetMessage('E0220');
      } else {
        // 利用予算人数取込処理
        this.importUseNumPeopleService.execute(selectedFiles[0], (data: any) => {
          const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
          // 画面ＩＤ
          inpVO.dispId = 'KYMW9400';
          // データ区分
          inpVO.dataDiv = KYMW0D00DataDiv.DATA_DIV_KYMW9400_USE_NUM_PEOPLE;
          // 正常件数
          inpVO.normalNum = data.NormalCount;
          // 注意件数
          inpVO.attentionNum = data.AttentionCount;
          // 異常件数
          inpVO.abnormalNum = data.AbnormalityCount;
          // ＤＢ更新件数
          inpVO.updateNum = data.DBExecuteCount;
          // 処理件数
          inpVO.manageNum = data.TotalExecuteCount;

          const ref = this.dialogService.openModal(KYMW0D00Component);
          const inst = ref.componentInstance as KYMW0D00Component;

          inst.parent = this;
          inst.setInterfaceParam(inpVO);
          inst.closeFunction = () => {
            ref.close();
          };
        });
      }
    }, [FileAccept.CSV]);
  }

  /**
   * 「按分比率」を選択した状態で、「取込」ボタンを押下時に呼び出されるメソッド。
   */
  public fileProportionalDistributionRatioUpload(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 拡張子取得(小文字に変換して取得する)
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      // 取得した拡張子が想定されているものかチェック
      if (extension !== 'csv') {
        this.dialogService.openAlertGetMessage('E0220');
      } else {
        // 按分比率取込処理
        this.importDistributionRatioService.execute(selectedFiles[0], (data: any) => {
          const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
          // 画面ＩＤ
          inpVO.dispId = 'KYMW9400';
          // データ区分
          inpVO.dataDiv = KYMW0D00DataDiv.DATA_DIV_KYMW9400_DISTRIBUTION;
          // 正常件数
          inpVO.normalNum = data.NormalCount;
          // 注意件数
          inpVO.attentionNum = data.AttentionCount;
          // 異常件数
          inpVO.abnormalNum = data.AbnormalityCount;
          // ＤＢ更新件数
          inpVO.updateNum = data.DBExecuteCount;
          // 処理件数
          inpVO.manageNum = data.TotalExecuteCount;

          const ref = this.dialogService.openModal(KYMW0D00Component);
          const inst = ref.componentInstance as KYMW0D00Component;

          inst.parent = this;
          inst.setInterfaceParam(inpVO);
          inst.closeFunction = () => {
            ref.close();
          };
        });
      }
    }, [FileAccept.CSV]);
  }

  /**
   * 「予算」を選択した状態で、「取込」ボタンを押下時に呼び出されるメソッド。
   */
  public fileBudgetUpload(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 拡張子取得(小文字に変換して取得する)
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      // 取得した拡張子が想定されているものかチェック
      if (extension !== 'csv') {
        this.dialogService.openAlertGetMessage('E0220');
      } else {
        // 予算取込処理
        this.importBudgetService.execute(selectedFiles[0], (data: any) => {
          const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
          // 画面ＩＤ
          inpVO.dispId = 'KYMW9400';
          // データ区分
          inpVO.dataDiv = KYMW0D00DataDiv.DATA_DIV_KYMW9400_BUDGET;
          // 正常件数
          inpVO.normalNum = data.NormalCount;
          // 注意件数
          inpVO.attentionNum = data.AttentionCount;
          // 異常件数
          inpVO.abnormalNum = data.AbnormalityCount;
          // ＤＢ更新件数
          inpVO.updateNum = data.DBExecuteCount;
          // 処理件数
          inpVO.manageNum = data.TotalExecuteCount;

          const ref = this.dialogService.openModal(KYMW0D00Component);
          const inst = ref.componentInstance as KYMW0D00Component;

          inst.parent = this;
          inst.setInterfaceParam(inpVO);
          inst.closeFunction = () => {
            ref.close();
          };
        });
      }
    }, [FileAccept.CSV]);
  }

  /**
   * 「取込」ボタン押下時イベント
   */
  public eventUpload_CLICKHandler(): void {
    if (this.KYMW9400Model.uploadType === '1') {
      //「営業日カレンダー」
      this.fileBusinessCalendarUpload();
    } else if (this.KYMW9400Model.uploadType === '2') {
      //「利用予算人数」
      this.fileUseBudgetNumberUpload();
    } else if (this.KYMW9400Model.uploadType === '3') {
      //「按分比率」
      this.fileProportionalDistributionRatioUpload();
    } else if (this.KYMW9400Model.uploadType === '4') {
      //「予算」
      this.fileBudgetUpload();
    }
  }
}
